import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { push } from "connected-react-router";
import { Result } from "antd";

const NoRoles = ({ push }) => {
  const { authenticated } = useSelector((state) => state.session);
  useEffect(() => {
    !authenticated && push("/sign-in");
  }, [push, authenticated]);

  return (
    <Result
      status="403"
      title={
        <FormattedMessage
          id="messages.noRoles"
          defaultMessage="Přístup odepřen"
        />
      }
      subTitle={
        <FormattedMessage
          id="messages.noRoles.info"
          defaultMessage="Nemáte dostatečné oprávnění pro přístup."
        />
      }
    />
  );
};

export default connect(null, { push })(NoRoles);
